import { createFormHook } from '@tanstack/react-form'

import { fieldContext, formContext } from './contexts'
import { CheckboxField, SelectField, TextareaField, TextField } from './fields'

const { useAppForm: usePopcornForm } = createFormHook({
  fieldComponents: {
    CheckboxField,
    SelectField,
    TextareaField,
    TextField,
  },
  formComponents: {},
  fieldContext,
  formContext,
})

export { usePopcornForm }
